import React, { useState, useEffect } from 'react';
import UnityPlayer from '../Components/UnityPlayer';
import { useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const GameDetailPage = () => {
  const { gameUrl } = useParams();
  const [gameData, setGameData] = useState(null);
  const [bg, setBg] = useState("/games/nes/bg.png");

  var frameStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '1920px',
    height: '1110px',
    margin: 'auto',
    background: `url(${bg}) no-repeat center center`,
    backgroundSize: 'cover',
    overflowY: 'auto',
    paddingTop: '159px',
  };

  useEffect(() => {
    import('../games.json')
      .then(data => {
        for (const category of data.default) {
          const foundGame = category.games.find(game => game.url === gameUrl);
          if (foundGame) {
            setGameData(foundGame);
            setBg(category.bg ? category.bg : null);
            break;
          }
        }
      });
  }, [gameUrl]);

  return (
    <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'start', justifyContent: 'center', backgroundColor: 'black' }}>
      <div key={bg} style={frameStyle}>
        {gameData && <UnityPlayer gameUrl={gameData.imageUrl}/>}
        {/*<h1>{gameData && gameData.name}</h1>
        {gameData && gameData.instructions}*/}
      </div>
    </div>
  );
};

export default GameDetailPage;